import { inject, Service } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Api } from '@api/api';
import { getPromoCodeByName as getPromoCodeByNameFn } from '@api/functions';
import type { PromoCodeDto } from '@api/models';
import { DeviceService } from '../../../../services/device-detector/device.service';

@Service()
export class PromoCodeService {
  private api = inject(Api);
  private deviceService = inject(DeviceService);

  private promoCode: PromoCodeDto;
  private savedPromoCode: string = 'kl.savedPromoCode';
  promoCodeUpdated$ = new Subject<PromoCodeDto>();
  get getPromoCode() { return this.promoCode; }

  constructor() {
    const storedPromoCode = this.getLocalStoragePromoCode();
    this.promoCode = storedPromoCode && storedPromoCode !== 'undefined' ? JSON.parse(storedPromoCode) : undefined;
    this.sendPromoCodeUpdatedData(this.promoCode);
  }

  sendPromoCodeUpdatedData(promoCode: PromoCodeDto) {
    this.promoCodeUpdated$.next(promoCode);
  }

  getPromoCodeByName(promoCodeName: string) {
    return this.api.invoke(getPromoCodeByNameFn, { name: promoCodeName });
  }

  getLocalStoragePromoCode() {
    if (this.deviceService.isPlatformBrowser()) {
      return localStorage.getItem(this.savedPromoCode);
    }
  }

  clearLocalStoragePromoCode() {
    if (this.deviceService.isPlatformBrowser()) {
      localStorage.removeItem(this.savedPromoCode);
    }
  }

  setLocalStoragePromoCode() {
    if (this.deviceService.isPlatformBrowser()) {
      localStorage.setItem(this.savedPromoCode, JSON.stringify(this.promoCode));
    }
  }

  cancelPromoCodeData() {
    this.clearLocalStoragePromoCode();
    this.promoCode = undefined;
    this.sendPromoCodeUpdatedData(this.promoCode);
  }

  applyPromoCode(inputValue: string): Observable<PromoCodeDto> {
    return this.getPromoCodeByName(inputValue)
      .pipe(tap(
        response => {
          this.promoCode = response;
          this.setLocalStoragePromoCode();
          this.sendPromoCodeUpdatedData(this.promoCode);
        },
        () => {
          this.cancelPromoCodeData();
        }
      ));
  }
}
